// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"c6e8ba5398--wrapper--Bwaev","title":"c6e8ba5398--title--BarZi","line":"c6e8ba5398--line--YeBbr","proofs":"c6e8ba5398--proofs--1afbf","proof":"c6e8ba5398--proof--3IvY4"};